export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getDistrictList: function getDistrictList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/district/get",
        method: "get",
        params: data
      });
    },
    getDistrictListByPy: function getDistrictListByPy() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/resource/".concat(data.city_id, "/districts/"),
        method: "get",
        params: data
      });
    },
    addDistrict: function addDistrict() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/district/add",
        method: "post",
        data: data
      });
    },
    updateDistrict: function updateDistrict() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/district/update",
        method: "post",
        data: data
      });
    },
    deleteDistrict: function deleteDistrict() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/district/delete",
        method: "post",
        data: data
      });
    },
    //更新
    refreshBusinessForDistrict: function refreshBusinessForDistrict(params) {
      return request({
        url: "/api/v3/frontend/refresh_feature_Districts",
        method: "get",
        params: params
      });
    }
  };
});